import { create } from "zustand";

interface HeroOverlapState {
  overDarkHero: boolean;
  setOverDarkHero: (v: boolean) => void;
}

export const useHeroOverlapStore = create<HeroOverlapState>((set) => ({
  overDarkHero: false,
  setOverDarkHero: (v) => set({ overDarkHero: v })
}));
